webpackJsonp([4,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(126);
	module.exports = __webpack_require__(249);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(90)
	
	/* script */
	__vue_exports__ = __webpack_require__(61)
	
	/* template */
	var __vue_template__ = __webpack_require__(108)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7ae6b4f1"
	
	module.exports = __vue_exports__


/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports) {

	'use strict';
	
	var $ = window.$;
	
	var _get = function _get() {
	    return $.ajax({
	        url: '/json/shopCity.json',
	        type: 'get',
	        dataType: 'json',
	        data: {
	            siteId: window._qiwa && window._qiwa.__site_basic.siteId
	        }
	    });
	};
	
	module.exports = {
	    _city: _get(),
	    get_async: function get_async() {
	        return this._city;
	    },
	    reget_async: function reget_async() {
	        return _get();
	    },
	    getByCode_async: function getByCode_async(code) {
	        return $.when(this.get_async()).then(function (data) {
	            if (!data) {
	                console.error('未知错误！');
	            } else if (data.code === 0 && data.item) {
	                var tmp_obj = {};
	                for (var i in data.item) {
	                    if (data.item[i].length && data.item[i][0].cityName && data.item[i][0].cityCode) {
	                        tmp_obj[data.item[i][0].cityCode] = data.item[i];
	                    }
	                }
	                if (!code) {
	                    return tmp_obj;
	                } else {
	                    return tmp_obj[code];
	                }
	            } else if (data.msg) {
	                console.error(data.code + ':' + data.msg);
	            } else {
	                console.error('未知错误！');
	            }
	            return false;
	        });
	    },
	    getCity_async: function getCity_async() {
	        return $.when(this.get_async()).then(function (data) {
	            if (!data) {
	                console.error('未知错误！');
	            } else if (data.code === 0 && data.item) {
	                var tmp = [];
	                var tmp_obj = {};
	                for (var i in data.item) {
	                    if (data.item[i].length && data.item[i][0].cityName && data.item[i][0].cityCode) {
	                        tmp_obj = {};
	                        tmp_obj['name'] = data.item[i][0].cityName;
	                        tmp_obj['code'] = data.item[i][0].cityCode;
	                        tmp.push(tmp_obj);
	                    }
	                }
	                return tmp;
	            } else if (data.msg) {
	                console.error(data.code + ':' + data.msg);
	            } else {
	                console.error('未知错误！');
	            }
	            return false;
	        });
	    },
	    getCityByCode_async: function getCityByCode_async(code) {
	        return $.when(this.get_async()).then(function (data) {
	            if (!data) {
	                console.error('未知错误！');
	            } else if (data.code === 0 && data.item) {
	                var tmp_obj = {};
	                for (var i in data.item) {
	                    if (data.item[i].length && data.item[i][0].cityName && data.item[i][0].cityCode) {
	                        tmp_obj[data.item[i][0].cityCode] = data.item[i][0].cityName;
	                    }
	                }
	                if (!code) {
	                    return tmp_obj;
	                } else {
	                    return tmp_obj[code];
	                }
	            } else if (data.msg) {
	                console.error(data.code + ':' + data.msg);
	            } else {
	                console.error('未知错误！');
	            }
	            return false;
	        });
	    }
	};

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getUserTag = getUserTag;
	
	var _userApi = __webpack_require__(44);
	
	function getUserTag() {
	    return (0, _userApi.getUserTag)().catch(function (e) {
	        console.error('getUserTag error', e);
	        return {
	            data: {
	                usertag: 'ERROR'
	            }
	        };
	    });
	}

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.jsonpInstance = undefined;
	
	var _promise = __webpack_require__(127);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _jsonp = __webpack_require__(150);
	
	var _jsonp2 = _interopRequireDefault(_jsonp);
	
	var _qs = __webpack_require__(152);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function jsonpInstance(url, params, opts) {
	    var urlProxy = '//' + window._qiwa.sys_global.webSettingsObject.trafficServer + url + '?' + _qs2.default.stringify(params);
	    return new _promise2.default(function (resolve, reject) {
	        (0, _jsonp2.default)(urlProxy, opts, function (err, data) {
	            if (err) {
	                reject(err);
	            } else {
	                resolve(data);
	            }
	        });
	    });
	}
	
	exports.jsonpInstance = jsonpInstance;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.addUserInfo2Cookie = addUserInfo2Cookie;
	exports.getUserTag = getUserTag;
	
	var _instance = __webpack_require__(43);
	
	function addUserInfo2Cookie(userPhone) {
	    return (0, _instance.jsonpInstance)('/api/userApi/addUserInfo2Cookie.jsonp', {
	        userPhone: userPhone
	    });
	}
	
	function getUserTag() {
	    return (0, _instance.jsonpInstance)('/api/userapi/getUserTag.jsonp', {
	        isSaveCookie: 1
	    });
	}

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	
	
	'use strict';
	
	__webpack_require__(80);

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	
	
	'use strict';

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	
	
	'use strict';
	
	__webpack_require__(81);
	
	var _vue = __webpack_require__(22);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _Announcement = __webpack_require__(95);
	
	var _Announcement2 = _interopRequireDefault(_Announcement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	    el: '.copyright',
	    template: '<div is="Announcement" :arg0="arg0">123</div>',
	    data: {
	        arg0: window._qiwa.site_global.annoncementList
	    },
	    components: {
	        Announcement: _Announcement2.default
	    }
	});

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	
	
	'use strict';

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	
	
	'use strict';
	
	__webpack_require__(50);

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var riot = __webpack_require__(153);
	riot.tag('pc-helpfind', '<div class="wrapper"> <helpfind-form if="{ !helpfindok }"></helpfind-form> <helpfind-ok if="{ helpfindok }"></helpfind-ok> </div>', 'pc-helpfind { display: block; width: 100%; height: 480px; min-width: 1180px; background-position: center; background-size: cover; } pc-helpfind > .wrapper { width: 1180px; height: 100%; margin: 0 auto; position: relative; }', function (opts) {
	    var that = this;
	    var s = this.root.style;
	    s.backgroundColor = opts.bgcolor ? opts.bgcolor : '#ff0';
	    s.backgroundImage = 'url(' + (opts.bgimg ? opts.bgimg : '//placehold.it/1688x480') + ')';
	    this.helpfindok = false;
	    riot.route(function (collection, id, action) {
	        if (collection == "helpfindsubmitok") {
	            that.helpfindok = true;
	            that.update();
	        } else if (collection == "alert") {
	            alert(id);
	            riot.route('/');
	        } else if (collection == "reinput") {
	            that.helpfindok = false;
	            that.update();
	        }
	    });
	});
	riot.tag('helpfind-ok', '<div class="helpfind-success"> <div class="success-icon"></div> <h1>您的找车申请已经提交成功</h1> <div class="success-jump"><span id="time-num">{ time }</span>秒钟后跳转到首页</div> <div class="success-link"><a href="/">立即去首页</a></div> <div class="success-explain"> <p>{ parent.opts.shopname }的工作人员将会尽快联系您</p> <p>感谢您对{ parent.opts.shopname }的支持！</p> </div> </div>', 'helpfind-ok { display: block; background: #fff; width: 310px; height: 260px; padding: 30px; position: absolute; right: 50px; top: 60px; font-size: 12px; } helpfind-ok .helpfind-success { width: 100%; height: 100%; text-align: center; } helpfind-ok .helpfind-success .success-icon { margin-top: 20px; width: 100%; height: 52px; background: url("//assets.souche.com/assets/images/sellcar/success.png") no-repeat scroll center center transparent; } helpfind-ok .helpfind-success h1 { font-weight: normal; } helpfind-ok .helpfind-success .success-explain{ border: 1px solid #D1D1D1; border-radius: 5px; height: 40px; background-color: #F9F9F9; padding: 20px; margin-top: 30px; margin-left: 5px; margin-right: 5px; } helpfind-ok .helpfind-success .success-explain p { line-height: 20px; margin: 0; }', function (opts) {
	    var that = this;
	    that.time = 5;
	    riot.route(function (collection, id, action) {
	        if (collection == "helpfindsubmitok") {
	            setTimeout(function () {
	                if (--that.time <= 0) {
	                    riot.route('reinput');
	                } else {
	                    riot.route(collection + '/' + that.time);
	                }
	                that.update();
	            }, 1000);
	        }
	    });
	});
	riot.tag('helpfind-form', '<div class="title"> 帮我找车 </div> <div class="body"> <helpfind-carmodel class="mb10"></helpfind-carmodel> <helpfind-price class="mb10"></helpfind-price> <helpfind-yearandmileage class="mb10"></helpfind-yearandmileage> <helpfind-description class="mb10"></helpfind-description> <helpfind-shop class="mb10"></helpfind-shop> <helpfind-cellphone class="mb10"></helpfind-cellphone> <helpfind-submit></helpfind-submit> </div>', 'helpfind-form { display: block; background: #fff; width: 390px; height: 385px; box-sizing: border-box; padding: 20px 36px 0 44px; position: absolute; right: 45px; top: 45px; } helpfind-form > .title { font-size: 22px; padding-bottom: 18px; font-family: \'Microsoft YaHei\'; color: #333; } helpfind-form > .body .mb10 { margin-bottom: 10px; }', function (opts) {});
	riot.tag('helpfind-shop', '<div class="value" id="value"> { showvalue } </div> <div class="selectbg" if="{ showselect }" id="selectbg"></div> <div class="select" if="{ showselect }"> <div class="city select-child"> <div class="title">请选择城市</div> <div class="body"> <div class="option" each="{ k, v in imDataCity }" onclick="{ parent.doSelectCity }" data-city="{ k }">{ k }</div> </div> </div> <div class="shop select-child"> <div class="title">请选择店铺</div> <div class="body" if="{ city }"> <div class="option" each="{ imDataShop }" onclick="{ parent.doSelectShop }" data-code="{ code }" data-shop="{ nickName }">{ nickName }</div> </div> <div class="body" if="{ !city }"> <div class="option">请先选择城市</div> </div> </div> </div> <label>*</label>', 'helpfind-shop { display: block; width: 100%; height: 32px; border: solid #ddd 1px; position: relative; font-size: 12px; box-sizing: border-box; } helpfind-shop .value { width: 300px; height: 100%; line-height: 30px; cursor: pointer; color: #999; padding-left: 10px; } helpfind-shop .selectbg { position: fixed; width: 100%; height: 100%; top: 0; left: 0; background: rgba(0,0,0,0.1); } helpfind-shop .select { box-sizing: border-box; width: 100%; height: 200px; border: #FF5517 solid 2px; position: absolute; right: 0; top: 30px; background: #fff; padding: 1px; z-index: 1; } helpfind-shop .select-child { box-sizing: border-box; width: 50%; height: 100%; float: left; padding: 5px; } helpfind-shop .select-child > .body { width: 100%; height: 160px; border: 1px solid #ddd; overflow-y: auto; } helpfind-shop .option { width: 95%; height: 30px; cursor: pointer; line-height: 30px; padding-left: 5%; } helpfind-shop .option:hover { background-color: #ddd; } helpfind-shop label { width: 30px; height: 30px; position: absolute; right: 0; top: 0; background: #fff; line-height: 30px; color: #d00; text-align: right; padding-right: 10px; }', function (opts) {
	    var that = this;
	    this.showselect = false;
	    that.exDataShop = $.cookie("shopId");
	    if (that.exDataShop) {
	        that.showvalue = that.parent.parent.opts.shopname;
	    } else {
	        that.showvalue = '请选择所在城市的店铺(必填)';
	    }
	    that.update();
	    this.value.onclick = function () {
	        if (that['imDataCity']) {
	            that.showselect = true;
	            that.update();
	        } else {
	            $.getJSON('/json/shopCity.json', {
	                siteId: $.cookie("siteId")
	            }, function (json, textStatus) {
	                if (json.code == 0) {
	                    that['imDataCity'] = json.item;
	                }
	                that.showselect = true;
	                that.update();
	            });
	        };
	    };
	    this.selectbg.onclick = function () {
	        that.exDataShop = "";
	        that.showvalue = '请选择所在城市的店铺(必填)';
	        that.showselect = false;
	        that.update();
	    };
	    this.doSelectCity = function (e) {
	        that.city = e.target.dataset.city;
	        that.imDataShop = that['imDataCity'][that.city];
	        this.showvalue = that.city + '-';
	        that.update();
	    }.bind(this);
	    this.doSelectShop = function (e) {
	        that.exDataShop = e.target.dataset.code;
	        this.showvalue = that.city + '-' + e.target.dataset.shop;
	        this.showselect = false;
	        that.update();
	    }.bind(this);
	});
	riot.tag('helpfind-submit', '<button id="submit" class="submit">提交</button>', 'helpfind-submit { display: block; width: 100%; height: 30px; } helpfind-submit .submit { display: block; width: 150px; height: 40px; background-color: #0F448E; font-size: 16px; color: #FFF; border: medium none; cursor: pointer; border-radius: 5px; }', function (opts) {
	    var that = this;
	    this.submit.style.backgroundColor = this.parent.parent.opts.bgcolor;
	    this.submit.onclick = function () {
	        var phoneReg = /^1[0-9]{10}$/;
	        var phoneNum = that.parent.tags['helpfind-cellphone'].getvalue();
	        if (!phoneReg.test(phoneNum)) {
	            riot.route('alert/请输入正确的手机号码');
	        } else if ($.cookie("crmUserId")) {
	            doSubmit();
	        } else {
	            doLogin();
	        }
	    };
	    function doSubmit() {
	        if (!that.parent.tags['helpfind-shop'].exDataShop) {
	            alert('请选择所在城市的店铺');
	            return false;
	        }
	        $.ajax({
	            url: '/json/findCar.json',
	            type: 'GET',
	            dataType: 'json',
	            data: {
	                brand: that.parent.tags['helpfind-carmodel'].exDataBrand,
	                series: that.parent.tags['helpfind-carmodel'].exDataSeries,
	                mileage: that.parent.tags['helpfind-yearandmileage'].getyear(),
	                year: that.parent.tags['helpfind-yearandmileage'].getmileage(),
	                priceMin: that.parent.tags['helpfind-price'].getPriceMin(),
	                priceMax: that.parent.tags['helpfind-price'].getPriceMax(),
	                cellphone: that.parent.tags['helpfind-cellphone'].getvalue(),
	                description: that.parent.tags['helpfind-description'].getvalue(),
	                siteId: that.parent.tags['helpfind-shop'].exDataShop,
	                crmUserId: $.cookie("crmUserId"),
	                shopId: $.cookie("shopId"),
	                platform: 'PLATFORM_WEB'
	            }
	        }).done(function () {
	            riot.route('helpfindsubmitok');
	        }).fail(function () {
	            console.log("error");
	        }).always(function () {
	            console.log("complete");
	        });
	    }
	    function doLogin() {
	        $.ajax({
	            url: 'json/login.json',
	            type: 'GET',
	            dataType: 'json',
	            data: {
	                phone: that.parent.tags['helpfind-cellphone'].getvalue()
	            }
	        }).done(function () {
	            doSubmit();
	        }).fail(function () {
	            console.log("error");
	        }).always(function () {
	            console.log("complete");
	        });
	    }
	});
	riot.tag('helpfind-cellphone', '<input type="text" name="{ name }" id="{ name }" placeholder="手机号码（必填）" value="{ parent.parent.opts.logined }"> <label for="{ name }">*</label>', 'helpfind-cellphone { display: block; width: 310px; height: 32px; border: solid #ddd 1px; position: relative; box-sizing: border-box; } helpfind-cellphone input { width: 296px; height: 28px; border: none; color: #666; padding-left: 10px; font-size: 12px; } helpfind-cellphone label { width: 30px; height: 30px; position: absolute; right: 0; top: 0; background: #fff; line-height: 30px; color: #d00; text-align: right; padding-right: 10px; }', function (opts) {
	    var that = this;
	    this.name = 'input' + Math.random();
	    this.getvalue = function () {
	        return that['{ name }'].value;
	    };
	});
	riot.tag('helpfind-description', '<input type="text" name="{ name }" id="{ name }" placeholder="其他描述"> <label for="{ name }"></label>', 'helpfind-description { display: block; width: 310px; height: 32px; border: solid #ddd 1px; position: relative; box-sizing: border-box; } helpfind-description input { width: 296px; height: 28px; border: none; color: #999; padding-left: 10px; font-size: 12px; } helpfind-description label { width: 30px; height: 30px; position: absolute; right: 0; top: 0; background: #fff; line-height: 30px; text-align: right; padding-right: 10px; }', function (opts) {
	    var that = this;
	    this.name = 'input' + Math.random();
	    this.getvalue = function () {
	        return that['{ name }'].value;
	    };
	});
	riot.tag('helpfind-yearandmileage', '<helpfind-year class="fl"></helpfind-year> <div class="c"></div> <helpfind-mileage class="fr"></helpfind-mileage>', 'helpfind-yearandmileage { position: relative; display: block; height: 32px; } helpfind-yearandmileage .fl { position: absolute; left: 0; top: 0; } helpfind-yearandmileage .fr { position: absolute; right: 0; top: 0; } helpfind-yearandmileage .c { width: 100%; height: 100%; text-align: center; color: #999; line-height: 30px; }', function (opts) {
	    var that = this;
	    this.getyear = function () {
	        return that.tags['helpfind-year'].exDataYear;
	    };
	    this.getmileage = function () {
	        return that.tags['helpfind-mileage'].exDataMileage;
	    };
	});
	riot.tag('helpfind-mileage', '<div class="value" id="value"> { showvalue } </div> <div class="selectbg" if="{ showselect }" id="selectbg"></div> <div class="select" if="{ showselect }"> <div class="year select-child"> <div class="title">请选择里程</div> <div class="body"> <div class="option" each="{ val, i in year }" onclick="{ parent.doSelectYear }" data-code="{ i + 1 }" data-name="{ val }">{ val }</div> </div> </div> </div>', 'helpfind-mileage { display: block; width: 148px; height: 30px; border: solid #ddd 1px; position: relative; } helpfind-mileage .value { width: 100%; height: 100%; line-height: 30px; cursor: pointer; color: #999; padding-left: 10px; font-size: 12px; } helpfind-mileage .selectbg { position: fixed; width: 100%; height: 100%; top: 0; left: 0; background: rgba(0,0,0,0.1); } helpfind-mileage .select { box-sizing: border-box; width: 100%; height: 200px; border: #FF5517 solid 2px; position: absolute; right: 0; top: 30px; background: #fff; padding: 1px; z-index: 1; } helpfind-mileage .select-child { box-sizing: border-box; width: 100%; height: 100%; float: left; padding: 5px; } helpfind-mileage .select-child > .body { width: 100%; height: 160px; border: 1px solid #ddd; overflow-y: auto; } helpfind-mileage .option { width: 95%; height: 30px; cursor: pointer; line-height: 30px; padding-left: 5%; font-size: 12px; } helpfind-mileage .option:hover { background-color: #ddd; }', function (opts) {
	    var that = this;
	    this.showselect = false;
	    this.showvalue = '里程';
	    this.value.onclick = function () {
	        that.year = [1, 3, 6, 10];
	        for (var i = that.year.length - 1; i >= 0; i--) {
	            that.year[i] = that.year[i] + '万公里内';
	        };
	        that.year.push('大于10万公里');
	
	        that.showselect = true;
	        that.update();
	    };
	    this.selectbg.onclick = function () {
	        that.showselect = false;
	        that.update();
	    };
	    this.doSelectYear = function (e) {
	        that.exDataMileage = e.target.dataset.code;
	        this.showvalue = e.target.dataset.name;
	        this.showselect = false;
	        that.update();
	    }.bind(this);
	});
	riot.tag('helpfind-year', '<div class="value" id="value"> { showvalue } </div> <div class="selectbg" if="{ showselect }" id="selectbg"></div> <div class="select" if="{ showselect }"> <div class="year select-child"> <div class="title">请选择年限</div> <div class="body"> <div class="option" each="{ val, i in year }" onclick="{ parent.doSelectYear }" data-code="{ i + 1 }" data-name="{ val }" >{ val }</div> </div> </div> </div>', 'helpfind-year { display: block; width: 148px; height: 30px; border: solid #ddd 1px; position: relative; } helpfind-year .value { width: 300px; height: 100%; line-height: 30px; cursor: pointer; color: #999; padding-left: 10px; font-size: 12px; } helpfind-year .selectbg { position: fixed; width: 100%; height: 100%; top: 0; left: 0; background: rgba(0,0,0,0.1); } helpfind-year .select { box-sizing: border-box; width: 100%; height: 200px; border: #FF5517 solid 2px; position: absolute; right: 0; top: 30px; background: #fff; padding: 1px; z-index: 1; } helpfind-year .select-child { box-sizing: border-box; width: 100%; height: 100%; float: left; padding: 5px; } helpfind-year .select-child > .body { width: 100%; height: 160px; border: 1px solid #ddd; overflow-y: auto; } helpfind-year .option { width: 95%; height: 30px; cursor: pointer; line-height: 30px; padding-left: 5%; font-size: 12px; } helpfind-year .option:hover { background-color: #ddd; }', function (opts) {
	    var that = this;
	    this.showselect = false;
	    this.showvalue = '年限';
	    this.value.onclick = function () {
	        that.year = [1, 2, 3, 5, 8, 10];
	        for (var i = that.year.length - 1; i >= 0; i--) {
	            that.year[i] = that.year[i] + '年内';
	        };
	        that.year.push('大于10年');
	
	        that.showselect = true;
	        that.update();
	    };
	    this.selectbg.onclick = function () {
	        that.showselect = false;
	        that.update();
	    };
	    this.doSelectYear = function (e) {
	        that.exDataYear = e.target.dataset.code;
	        this.showvalue = e.target.dataset.name;
	        this.showselect = false;
	        that.update();
	    }.bind(this);
	});
	riot.tag('helpfind-price', '<helpfind-pricemin class="fl"></helpfind-pricemin> <div class="c">-</div> <helpfind-pricemax class="fr"></helpfind-pricemax>', 'helpfind-price { position: relative; display: block; height: 32px; } helpfind-price .fl { position: absolute; left: 0; top: 0; } helpfind-price .fr { position: absolute; right: 0; top: 0; } helpfind-price .c { width: 100%; height: 30px; line-height: 30px; text-align: center; color: #999; }', function (opts) {
	    var that = this;
	    this.getPriceMin = function () {
	        return that.tags['helpfind-pricemin'].getvalue();
	    };
	    this.getPriceMax = function () {
	        return that.tags['helpfind-pricemax'].getvalue();
	    };
	});
	riot.tag('helpfind-pricemin', '<input riot-type={"number"} name="{ name }" id="{ name }" > <label for="{ name }">万元</label>', 'helpfind-pricemin { display: block; width: 148px; height: 30px; border: solid #ddd 1px; position: relative; box-sizing: content-box; } helpfind-pricemin input { width: 137px; height: 28px; border: none; color: #999; padding-left: 10px; font-size: 12px; } helpfind-pricemin label { width: 30px; height: 30px; position: absolute; right: 0; top: 0; background: #fff; line-height: 30px; text-align: right; padding-right: 10px; font-size: 12px; color: #999; }', function (opts) {
	    var that = this;
	    this.name = 'input' + Math.random();
	    this.getvalue = function () {
	        return that['{ name }'].value;
	    };
	});
	riot.tag('helpfind-pricemax', '<input riot-type={"number"} name="{ name }" id="{ name }" > <label for="{ name }">万元</label>', 'helpfind-pricemax { display: block; width: 148px; height: 30px; border: solid #ddd 1px; position: relative; } helpfind-pricemax input { width: 137px; height: 28px; border: none; color: #999; padding-left: 10px; font-size: 12px; } helpfind-pricemax label { width: 30px; height: 30px; position: absolute; right: 0; top: 0; background: #fff; line-height: 30px; text-align: right; padding-right: 10px; font-size: 12px; color: #999; }', function (opts) {
	    var that = this;
	    this.name = 'input' + Math.random();
	    this.getvalue = function () {
	        return that['{ name }'].value;
	    };
	});
	riot.tag('helpfind-carmodel', '<div class="value" id="value"> { showvalue } </div> <div class="selectbg" if="{ showselect }" id="selectbg"></div> <div class="select" if="{ showselect }"> <div class="brand select-child"> <div class="title">请选择品牌</div> <div class="body"> <div class="option" each="{ imDataBrand }" onclick="{ parent.doSelectBrand }" data-code="{ code }" data-name="{ name }">{ name }</div> </div> </div> <div class="series select-child"> <div class="title">请选择车系</div> <div class="body" if="{ exDataBrand }"> <div class="optgroup" each="{ name, value in imDataSeries }"> <div class="optgrouplabel">{ name }</div> <div class="option" each="{ value }" onclick="{ parent.parent.doSelectSeries }" data-code="{ code }" data-name="{ name }">{ name }</div> </div> </div> <div class="body" if="{ !exDataBrand }"> <div class="option">请先选择品牌</div> </div> </div> </div>', 'helpfind-carmodel { display: block; width: 100%; height: 32px; border: solid #ddd 1px; position: relative; box-sizing: border-box; } helpfind-carmodel .value { width: 300px; height: 100%; line-height: 30px; cursor: pointer; color: #999; padding-left: 10px; font-size: 12px; } helpfind-carmodel .selectbg { position: fixed; width: 100%; height: 100%; top: 0; left: 0; background: rgba(0,0,0,0.1); } helpfind-carmodel .select { box-sizing: border-box; width: 100%; height: 200px; border: #FF5517 solid 2px; position: absolute; right: 0; top: 30px; background: #fff; padding: 1px; z-index: 1; } helpfind-carmodel .select-child { box-sizing: border-box; width: 50%; height: 100%; float: left; padding: 5px; } helpfind-carmodel .select-child > .body { width: 100%; height: 160px; border: 1px solid #ddd; overflow-y: auto; } helpfind-carmodel .optgrouplabel { background: #999; color: #fff; font-size: 12px; } helpfind-carmodel .option { width: 95%; height: 30px; cursor: pointer; line-height: 30px; padding-left: 5%; font-size: 12px; } helpfind-carmodel .option:hover { background-color: #ddd; }', function (opts) {
	    var that = this;
	    this.showselect = false;
	    that.showvalue = '选择车型';
	    this.value.onclick = function (e) {
	        if (that['imDataBrand']) {
	            that.showselect = true;
	            that.update();
	        } else {
	            $.getJSON('/json/dict/loadRootLevel.json', {
	                type: 'car-subdivision'
	            }, function (json, textStatus) {
	                if (json.code == 0) {
	                    that['imDataBrand'] = json.data;
	                }
	                that.showselect = true;
	                that.update();
	            });
	        };
	    };
	    this.selectbg.onclick = function () {
	        that.showselect = false;
	        that.update();
	    };
	    this.doSelectBrand = function (e) {
	        that.exDataBrand = e.target.dataset.code;
	        that.showvalue = e.target.dataset.name;
	        $.getJSON('/json/dict/loadRootLevelForCar.json', {
	            type: 'car-subdivision',
	            code: that.exDataBrand
	        }, function (json, textStatus) {
	            if (json.code == 0) {
	                that['imDataSeries'] = json.data.codes;
	            }
	            that.update();
	        });
	    }.bind(this);
	    this.doSelectSeries = function (e) {
	        that.exDataSeries = e.target.dataset.code;
	        that.showvalue = e.target.dataset.name;
	        that.showselect = false;
	        that.update();
	    }.bind(this);
	});
	
	riot.mount('pc-helpfind');

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	
	
	'use strict';
	
	__webpack_require__(82);
	
	var $ = window.$;
	
	$('.image').each(function (index, el) {
	    var $this = $(el);
	    var imgSrc = $this.find('img').attr('src');
	    if (imgSrc) {
	        $('<div class="image-banner"></div>').css({
	            'background-image': 'url(' + imgSrc + ')'
	        }).appendTo($(el));
	    }
	});

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	
	
	'use strict';
	
	var _assign = __webpack_require__(34);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _vue = __webpack_require__(22);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _Default = __webpack_require__(96);
	
	var _Default2 = _interopRequireDefault(_Default);
	
	var _vueLazyload = __webpack_require__(41);
	
	var _vueLazyload2 = _interopRequireDefault(_vueLazyload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueLazyload2.default);
	
	window.$('.module_newcar').each(function (i, v) {
	    var $v = window.$(v);
	    var app = new _vue2.default((0, _assign2.default)(_Default2.default, {
	        propsData: {
	            dataId: $v.attr('data-id'),
	            dataPositionindex: $v.attr('data-positionindex')
	        }
	    }));
	    app.$mount(v);
	});

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	
	
	'use strict';
	
	var _assign = __webpack_require__(34);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _vue = __webpack_require__(22);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _Default = __webpack_require__(99);
	
	var _Default2 = _interopRequireDefault(_Default);
	
	var _vueLazyload = __webpack_require__(41);
	
	var _vueLazyload2 = _interopRequireDefault(_vueLazyload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueLazyload2.default);
	
	window.$('.module_recommend').each(function (i, v) {
	    var $v = window.$(v);
	    var app = new _vue2.default((0, _assign2.default)(_Default2.default, {
	        propsData: {
	            dataId: $v.attr('data-id'),
	            dataPositionindex: $v.attr('data-positionindex')
	        }
	    }));
	    app.$mount(v);
	});

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	
	
	'use strict';
	
	__webpack_require__(83);
	
	__webpack_require__(123);
	
	var _sellcar_main = __webpack_require__(56);
	
	var _sellcar_main2 = _interopRequireDefault(_sellcar_main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = window.$;
	var _store = {
	    $html: $('.sellcar'),
	    $wrapper: $('<div class="wrapper">')
	};
	
	var _control = {
	    init: function init() {
	        this.bind();
	    },
	    bind: function bind() {
	        var bgimg = _store.$html.attr('bgimg');
	        if (bgimg && bgimg !== '[]') {
	            _store.$html.css({
	                'background-image': 'url(' + bgimg + ')'
	            });
	        } else {
	            _store.$html.css({
	                'background-image': 'url(//img.souche.com/20160422/png/2d11c94ba8126522b408b79596c54086.png)'
	            });
	            $('<div class="sellcar__h1">').text(window._qiwa && window._qiwa.__basic_site_default_shop && window._qiwa.__basic_site_default_shop.nickname + '\u4E13\u4E1A\u8BC4\u4F30').appendTo(_store.$wrapper);
	        }
	        _store.$wrapper.append(_sellcar_main2.default.$dom).appendTo(_store.$html);
	    }
	};
	
	_control.init();

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(151);
	var tpl = __webpack_require__(92);
	var handle = _.template(tpl, { variable: 'data' });
	
	var cityService = __webpack_require__(23);
	
	var $ = window.$;
	
	var _store = {
	    $dom: $('<div>'),
	
	    $html: {},
	    callback: function callback(code) {},
	    activeCode: $.cookie('ipCity')
	};
	
	var _control = {
	    init: function init() {
	        var that = this;
	        $.when(cityService.getCity_async()).then(function (data) {
	            if (!data) {
	                console.error('未知错误');
	            } else {
	                var html = handle({
	                    data: {
	                        '城市': data
	                    },
	                    activeCode: _store.activeCode
	                });
	                that.bind(html);
	            }
	        });
	    },
	
	    bind: function bind(html) {
	        _store.$html = $(html).addClass('hidden').appendTo(_store.$dom);
	        _store.$html.find('.slide-mask-layer').on('click', function (event) {
	            event.preventDefault();
	            _store.$html.addClass('hidden');
	        });
	        _store.$html.find('.slide-item').on('click', function (event) {
	            event.preventDefault();
	            var code = $(this).attr('data-code');
	            _store.callback(code);
	        });
	    }
	};
	
	_control.init();
	
	module.exports = {
	    $dom: _store.$dom,
	    do: function _do(callback) {
	        _store.$html.removeClass('hidden');
	        _store.callback = function (code) {
	            _store.$html.addClass('hidden');
	            callback(code);
	        };
	    },
	    _more: ''
	};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends2 = __webpack_require__(128);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var is = __webpack_require__(124);
	
	var select_city = __webpack_require__(55);
	var cityService = __webpack_require__(23);
	var userApi = __webpack_require__(42);
	
	var tpl = __webpack_require__(93);
	
	var $ = window.$;
	
	var _store = {
	    $dom: $('<div>'),
	    $html: {},
	    activeCode: $.cookie('ipCity'),
	    _more: ''
	};
	
	var _services = {
	    saveSellCar: function saveSellCar(data) {
	        return userApi.getUserTag().then(function (getUserTagData) {
	            return $.ajax({
	                url: '/jsonp/api/sellCar.json',
	                type: 'get',
	                dataType: 'jsonp',
	                data: (0, _extends3.default)({}, data, {
	                    usertag: getUserTagData.data.usertag
	                })
	            });
	        });
	    },
	    login: function login(phone) {
	        return $.ajax({
	            url: '/json/login.json',
	            type: 'post',
	            dataType: 'json',
	            data: {
	                phone: phone
	            }
	        });
	    }
	};
	
	var _control = {
	    init: function init() {
	        this.bind(tpl);
	    },
	    bind: function bind(html) {
	        _store.$html = $(html).on('click', '.J_select_city', function (event) {
	            event.preventDefault();
	            select_city.do(function (code) {
	                $.when(cityService.getCityByCode_async(code)).then(function (data) {
	                    _store.$html.find('.J_select_city').attr('data-value', code).find('.section_select').removeClass('select_default').find('.select_value').text(data);
	                });
	            });
	        }).on('click', '.J_submit_sale', function (event) {
	            event.preventDefault();
	            var $this = $(this);
	
	            var ex_data = {
	                phone: $('.J_input_phone').val()
	            };
	
	            if (!is.phone(ex_data.phone)) {
	                alert('请输入正确的手机号');
	                return false;
	            }
	
	            var cityCode = _store.$html.find('.J_select_city').attr('data-value');
	            if (!cityCode) {
	                alert('请选择一个城市');
	                return false;
	            }
	
	            $this.removeClass('J_submit_sale').addClass('disabled').text('正在提交...');
	            $.when(_services.login(ex_data.phone), cityService.getByCode_async(cityCode)).then(function (login_data, city_data) {
	                var data;
	                if (login_data[1] === 'success') {
	                    data = login_data[0];
	                } else {
	                    return false;
	                }
	                if (!data) {
	                    console.error('未知错误！');
	                } else if (data.code === 0 && data.item && data.item.crmUserId) {
	                    ex_data.crmUserId = data.item.crmUserId;
	                    ex_data.shopId = city_data[0].code;
	                    ex_data.seller = _store.$html.find('.J_input_name').val();
	                    ex_data.desc = _store.$html.find('.J_input_desc').val();
	                    return _services.saveSellCar(ex_data);
	                } else if (data.msg) {
	                    alert(data.code + ':' + data.msg);
	                } else {
	                    alert('未知错误！');
	                }
	                return false;
	            }).then(function (data) {
	                if (!data) {
	                    console.error('未知错误！');
	                } else {
	                    alert('提交成功，稍后客服会主动联系您，请确保您的手机号可以联系到您.');
	                    $this.text('已成功预约卖车');
	                }
	            });
	        }).appendTo(_store.$dom);
	
	        _store.$html.find('.select_city').append(select_city.$dom);
	
	        $('body').on('click', function (event) {
	            if (!$(event.target).closest(_store.$html.find('.select_city')).length) {
	                select_city.$dom.find('.slide-select-wrapper').addClass('hidden');
	            }
	        });
	
	        if (!_store.activeCode) {
	            $.when(cityService.getCity_async()).then(function (data) {
	                _store.$html.find('.J_select_city').attr('data-value', data[0].code).find('.select_value').text(data[0].name);
	            });
	        } else {
	            $.when(cityService.getCityByCode_async(_store.activeCode)).then(function (data) {
	                if (!data) {
	                    return $.when(cityService.getCity_async());
	                } else {
	                    _store.$html.find('.J_select_city').attr('data-value', _store.activeCode).find('.select_value').text(data);
	                    return false;
	                }
	            }).then(function (data) {
	                if (!data) {
	                    return false;
	                } else {
	                    _store.$html.find('.J_select_city').attr('data-value', data[0].code).find('.select_value').text(data[0].name);
	                    return false;
	                }
	            });
	        }
	    },
	    _more: ''
	};
	
	_control.init();
	
	module.exports = {
	    $dom: _store.$dom,
	    _more: ''
	};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	
	
	'use strict';
	
	__webpack_require__(84);
	
	(function () {
	    var $ = window.$;
	    $(document).ready(function () {
	        var c = {
	            height: 145
	        };
	
	        if (window._qiwa && window._qiwa.__site_basic.siteId === '233') {
	            c.height = 87;
	        }
	
	        $('.advisor-tip-close').click(function (e) {
	            e.preventDefault();
	            $('.my-advisor-tip').addClass('hidden');
	            $('#advisor_notice').addClass('hidden');
	            $.cookie('f2e_guwen_close', '1', {
	                expires: 1
	            });
	            e.stopPropagation();
	        });
	        var siderbarShow = false;
	        var showSidebar = function showSidebar(self) {
	
	            $('.sidebar .side-box').removeClass('active');
	            $(self.parentNode).addClass('active');
	            if (!$('#toolbar').hasClass('sidebar-active')) {
	                $('#toolbar').animate({
	                    width: 905,
	                    height: $(window).height() - 20 > 500 ? 500 : $(window).height() - 20
	                }, 500, function () {
	                    siderbarShow = true;
	                });
	                $('.sidebar  iframe').css({
	                    height: ($(window).height() - 20 > 500 ? 500 : $(window).height() - 20) - 32
	                });
	                $('#toolbar').addClass('sidebar-active');
	                $('.sidebar').removeClass('active');
	            }
	            $('.toolbar-content iframe').attr('src', $(self).attr('href'));
	            $('.toolbar-content .iframe-loading').removeClass('hidden');
	            $('.toolbar-content iframe').load(function () {
	                $(this).removeClass('hidden');
	                $('.toolbar-content .iframe-loading').addClass('hidden');
	            });
	        };
	        $('.sidebar').click(function (e) {
	            e.stopPropagation();
	        });
	        $('.sidebar .side-trigger').click(function (e) {
	
	            var self = this;
	            if ($(this).hasClass('collect-box')) {
	                e.preventDefault();
	                showSidebar(self);
	            }
	        });
	        $('#my-advisor').on('mouseenter', function () {
	            $('#my-advisor').addClass('active');
	        }).mouseleave(function () {
	            $('#my-advisor').removeClass('active');
	        });
	
	        $('.sidebar').on('mouseenter', function () {
	            if (!$('.sidebar').hasClass('sidebar-active')) {
	                $('.sidebar').addClass('active');
	            }
	        }).mouseleave(function () {
	            $('.sidebar').removeClass('active');
	        });
	        $('.toolbar-close').click(function () {
	            $('#toolbar').animate({
	                width: 52,
	                height: c.height
	            }, 500, function () {});
	            $('#toolbar').removeClass('sidebar-active');
	            siderbarShow = false;
	        });
	        $(document.body).click(function () {
	            if (siderbarShow) {
	                $('#toolbar').animate({
	                    width: 52,
	                    height: c.height
	                }, 500, function () {});
	                $('#toolbar').removeClass('sidebar-active');
	                siderbarShow = false;
	            }
	        });
	        $('#noreg-popup').on('click', function (e) {
	            e.stopPropagation();
	        });
	        $(window).scroll(function () {
	            if ($(window).scrollTop() > 0) {
	
	                $('#toTop').show('slow');
	            } else {
	                $('#toTop').hide('slow');
	            }
	        });
	        $('#toTop').click(function () {
	            $('html,body').animate({
	                scrollTop: 0
	            });
	        });
	    });
	})();

/***/ }),
/* 58 */
/***/ (function(module, exports) {

	
	
	'use strict';

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	
	
	'use strict';
	
	__webpack_require__(149);
	
	var $ = window.$;
	
	$('img[data-original]').lazyload({
	    effect: 'fadeIn'
	});

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _image = __webpack_require__(125);
	
	var _image2 = _interopRequireDefault(_image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    props: {
	        data: {
	            type: Object,
	            default: function _default() {
	                return {};
	            },
	            validator: function validator(value) {
	                return true;
	            }
	        },
	        'v-lazy': {
	            type: Boolean,
	            default: function _default() {
	                return !!(this.__proto__ && this.__proto__.__proto__ && this.__proto__.__proto__.$Lazyload);
	            }
	        },
	        'width': {
	            type: Number,
	            default: 240
	        }
	    },
	    computed: {
	        isNew: function isNew() {
	            return this.data.carType === 1 || this.data.carType === 3;
	        },
	        hasTangeche: function hasTangeche() {
	            return this.data.consignment === 1 || this.data.secLeaseStatus === 3 || this.isToolNewTangeche;
	        },
	        isToolNewTangeche: function isToolNewTangeche() {
	            return this.data.toolNewTangeche;
	        },
	        supportloan: function supportloan() {
	            if (!this.hasTangeche) {
	                return this.data.supportLoan;
	            }
	        },
	        computedImg: function computedImg() {
	            return this.data.bigImage ? _image2.default.formatUrl(this.data.bigImage, ~~(this.width - 2), ~~(this.width / 3 * 2)) : '';
	        }
	    }
	};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Default = __webpack_require__(94);
	
	var _Default2 = _interopRequireDefault(_Default);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    props: {
	        data: {
	            type: Object,
	            default: function _default() {
	                return {};
	            },
	            validator: function validator(value) {
	                return true;
	            }
	        },
	        'v-lazy': null
	    },
	    components: {
	        Default: _Default2.default
	    }
	};

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    props: ['arg0'],
	    computed: {
	        announcementText: function announcementText() {
	            var ret = [];
	            this.arg0.forEach(function (v) {
	                if (!v.image) {
	                    ret.push(v);
	                }
	            });
	            return ret;
	        },
	        announcementImage: function announcementImage() {
	            var ret = [];
	            this.arg0.forEach(function (v) {
	                if (v.image) {
	                    ret.push(v);
	                }
	            });
	            return ret;
	        }
	    },
	    methods: {
	        formatUrl: function formatUrl(url) {
	            if (!url) {
	                return false;
	            }
	            if (url.indexOf('http://') !== 0 && url.indexOf('https://') !== 0 && url.indexOf('/') !== 0) {
	                url = '//' + url;
	            }
	            return url;
	        }
	    }
	};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _TemplateAmyOrBetty = __webpack_require__(97);
	
	var _TemplateAmyOrBetty2 = _interopRequireDefault(_TemplateAmyOrBetty);
	
	var _TemplateCrystalOrSouche = __webpack_require__(98);
	
	var _TemplateCrystalOrSouche2 = _interopRequireDefault(_TemplateCrystalOrSouche);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    props: ['dataId', 'dataPositionindex'],
	    components: {
	        TemplateAmyOrBetty: _TemplateAmyOrBetty2.default,
	        TemplateCrystalOrSouche: _TemplateCrystalOrSouche2.default
	    },
	    data: function data() {
	        return {
	            isShow: true
	        };
	    },
	
	    computed: {
	        carList: function carList() {
	            return window._qiwa.site_global.newList;
	        },
	        templateId: function templateId() {
	            return window._qiwa.sys_global.__basic_template_id;
	        },
	        template: function template() {
	            if (this.templateId === 'template_amy' || this.templateId === 'template_betty') {
	                return 'TemplateAmyOrBetty';
	            } else if (this.templateId === 'template_crystal' || this.templateId === 'template_souche') {
	                return 'TemplateCrystalOrSouche';
	            }
	        }
	    }
	};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Large = __webpack_require__(10);
	
	var _Large2 = _interopRequireDefault(_Large);
	
	var _carUtil = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    props: ['carList'],
	    computed: {
	        carListComputed: function carListComputed() {
	            return this.carList;
	        },
	        lineHeightLevel: function lineHeightLevel() {
	            var retNum = 0;
	            var tangeche = false;
	            var loan = false;
	            for (var i = 0; i < this.carList.length; i++) {
	                var lineHeightLevel = (0, _carUtil.getLineHeightLevel)(this.carList[i]);
	                if (lineHeightLevel > retNum) {
	                    retNum = lineHeightLevel;
	                }
	            }
	            return retNum;
	        }
	    },
	    components: {
	        CarItem: _Large2.default
	    }
	};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Large = __webpack_require__(10);
	
	var _Large2 = _interopRequireDefault(_Large);
	
	var _carUtil = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    props: ['carList'],
	    computed: {
	        carListComputed: function carListComputed() {
	            return this.carList;
	        },
	        lineHeightLevel: function lineHeightLevel() {
	            var retNum = 0;
	            var tangeche = false;
	            var loan = false;
	            for (var i = 0; i < this.carList.length; i++) {
	                var lineHeightLevel = (0, _carUtil.getLineHeightLevel)(this.carList[i]);
	                if (lineHeightLevel > retNum) {
	                    retNum = lineHeightLevel;
	                }
	            }
	            return retNum;
	        }
	    },
	    components: {
	        CarItem: _Large2.default
	    }
	};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _TemplateAmyOrBetty = __webpack_require__(100);
	
	var _TemplateAmyOrBetty2 = _interopRequireDefault(_TemplateAmyOrBetty);
	
	var _TemplateCrystalOrSouche = __webpack_require__(101);
	
	var _TemplateCrystalOrSouche2 = _interopRequireDefault(_TemplateCrystalOrSouche);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    props: ['dataId', 'dataPositionindex'],
	    components: {
	        TemplateAmyOrBetty: _TemplateAmyOrBetty2.default,
	        TemplateCrystalOrSouche: _TemplateCrystalOrSouche2.default
	    },
	    data: function data() {
	        return {
	            isShow: true
	        };
	    },
	
	    computed: {
	        carList: function carList() {
	            return window._qiwa.site_global.recommList;
	        },
	        templateId: function templateId() {
	            return window._qiwa.sys_global.__basic_template_id;
	        },
	        template: function template() {
	            if (this.templateId === 'template_amy' || this.templateId === 'template_betty') {
	                return 'TemplateAmyOrBetty';
	            } else if (this.templateId === 'template_crystal' || this.templateId === 'template_souche') {
	                return 'TemplateCrystalOrSouche';
	            }
	        }
	    }
	};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Large = __webpack_require__(10);
	
	var _Large2 = _interopRequireDefault(_Large);
	
	var _carUtil = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    props: ['carList'],
	    computed: {
	        carListComputed: function carListComputed() {
	            return this.carList;
	        },
	        lineHeightLevel: function lineHeightLevel() {
	            var retNum = 0;
	            for (var i = 0; i < this.carList.length; i++) {
	                var lineHeightLevel = (0, _carUtil.getLineHeightLevel)(this.carList[i]);
	                if (lineHeightLevel > retNum) {
	                    retNum = lineHeightLevel;
	                }
	            }
	            return retNum;
	        }
	    },
	    components: {
	        CarItem: _Large2.default
	    }
	};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Large = __webpack_require__(10);
	
	var _Large2 = _interopRequireDefault(_Large);
	
	var _carUtil = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    props: ['carList'],
	    computed: {
	        carListComputed: function carListComputed() {
	            return this.carList;
	        },
	        lineHeightLevel: function lineHeightLevel() {
	            var retNum = 0;
	            for (var i = 0; i < this.carList.length; i++) {
	                var lineHeightLevel = (0, _carUtil.getLineHeightLevel)(this.carList[i]);
	                if (lineHeightLevel > retNum) {
	                    retNum = lineHeightLevel;
	                }
	            }
	            return retNum;
	        }
	    },
	    components: {
	        CarItem: _Large2.default
	    }
	};

/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 84 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 85 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 86 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 87 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 88 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 91 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	module.exports = "<section class=\"slide-select-wrapper animated\"> <div class=slide-mask-layer></div> <div class=slide-item-container> <% for (var key in data.data) { %> <div class=slide-item-group> <% for (var i = 0; i < data.data[key].length; i++) { %> <div class=slide-item data-code=\"<%= data.data[key][i].code %>\"><%= data.data[key][i].name %><i class=\"slide-active-logo iconfont\">√</i></div> <% } %> </div> <% } %> </div> </section>";

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	module.exports = "<div class=sellcar_main> <div class=sale_title>预约卖车</div> <div class=\"sale_section sale_phone\"> <div class=section_key> 联系方式（必填） </div> <div class=section_value> <input class=J_input_phone placeholder=请输入手机号(必填)> </div> </div> <div class=sale_section> <div class=section_key> 姓名 </div> <div class=section_value> <input class=J_input_name placeholder=请输入姓名> </div> </div> <div class=sale_section> <div class=section_key> 车辆描述 </div> <div class=section_value> <input class=J_input_desc placeholder=车辆描述，如：14款奥迪A3，2万公里> </div> </div> <div class=\"sale_section select_city\"> <div class=section_key> 所在城市 </div> <div class=\"section_value J_select_city\"> <div class=\"section_select select_default\" data-value=\"\"><span class=select_value>所在城市，请选择</span><i class=iconfont></i></div> </div> </div> <div class=sale_btn_group> <div class=\"btn btn-qiwa sale_btn J_submit_sale\">预约卖车</div> </div> </div>";

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(87)
	
	/* script */
	__vue_exports__ = __webpack_require__(60)
	
	/* template */
	var __vue_template__ = __webpack_require__(105)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-48f5a512"
	
	module.exports = __vue_exports__


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(88)
	
	/* script */
	__vue_exports__ = __webpack_require__(62)
	
	/* template */
	var __vue_template__ = __webpack_require__(106)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-508fae43"
	
	module.exports = __vue_exports__


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(63)
	
	/* template */
	var __vue_template__ = __webpack_require__(103)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(91)
	
	/* script */
	__vue_exports__ = __webpack_require__(64)
	
	/* template */
	var __vue_template__ = __webpack_require__(110)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-de0e7fd6"
	
	module.exports = __vue_exports__


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(89)
	
	/* script */
	__vue_exports__ = __webpack_require__(65)
	
	/* template */
	var __vue_template__ = __webpack_require__(107)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5637d3be"
	
	module.exports = __vue_exports__


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(66)
	
	/* template */
	var __vue_template__ = __webpack_require__(109)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(86)
	
	/* script */
	__vue_exports__ = __webpack_require__(67)
	
	/* template */
	var __vue_template__ = __webpack_require__(104)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-41d8c402"
	
	module.exports = __vue_exports__


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(85)
	
	/* script */
	__vue_exports__ = __webpack_require__(68)
	
	/* template */
	var __vue_template__ = __webpack_require__(102)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-154d4b12"
	
	module.exports = __vue_exports__


/***/ }),
/* 102 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "tangeche tangehce-template-amy-or-souche"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "carsContent"
	  }, [_c('div', {
	    staticClass: "hotNewCars"
	  }, _vm._l((_vm.carListComputed), function(item) {
	    return _c('div', {
	      staticClass: "car-item-container"
	    }, [_c('a', {
	      attrs: {
	        "href": '/car/' + item.id
	      }
	    }, [_c("CarItem", {
	      tag: "div",
	      staticClass: "car-item",
	      class: ['line-height-level-' + _vm.lineHeightLevel],
	      attrs: {
	        "data": item
	      }
	    })])])
	  }))])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "moduleTitle"
	  }, [_vm._v("推荐车辆"), _c('a', {
	    staticClass: "more",
	    attrs: {
	      "href": "/buy.htm",
	      "target": "_blank"
	    }
	  }, [_vm._v("更多>>")])])
	}]}

/***/ }),
/* 103 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "module_newcar",
	    attrs: {
	      "id": 'module_' + _vm.dataId,
	      "data-positionindex": _vm.dataPositionindex,
	      "data-id": _vm.dataId
	    }
	  }, [(_vm.isShow) ? _c(_vm.template, {
	    tag: "div",
	    attrs: {
	      "carList": _vm.carList
	    }
	  }) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "tangeche tangeche-template-amy-or-betty"
	  }, [_c('div', {
	    staticClass: "wrapper"
	  }, [_c('div', {
	    staticClass: "module-title"
	  }, [_vm._v("推荐车辆")]), _vm._v(" "), _c('div', {
	    staticClass: "module-desc"
	  }, [_vm._v("好车推荐，总有一款适合您")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "module-body"
	  }, [_c('div', {
	    staticClass: "show-card-wrapper"
	  }, _vm._l((_vm.carListComputed), function(item) {
	    return _c('div', {
	      staticClass: "car-item-container"
	    }, [_c('a', {
	      attrs: {
	        "href": '/car/' + item.id
	      }
	    }, [_c("CarItem", {
	      tag: "div",
	      staticClass: "car-item",
	      class: ['line-height-level-' + _vm.lineHeightLevel],
	      attrs: {
	        "data": item
	      }
	    })])])
	  }))])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "module-more"
	  }, [_c('a', {
	    attrs: {
	      "href": "/buy.htm",
	      "target": "_blank"
	    }
	  }, [_vm._v("查看更多")])])
	}]}

/***/ }),
/* 105 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "car-item",
	    class: {
	      'height-level-0': !_vm.hasTangeche,
	      'height-level-1': _vm.hasTangeche && !_vm.data.price,
	        'height-level-2': _vm.hasTangeche && _vm.data.price,
	        'height-level-2': _vm.supportloan
	    },
	    style: ({
	      width: _vm.width + 'px'
	    }),
	    attrs: {
	      "data-id": _vm.data.id
	    }
	  }, [_c('div', {
	    staticClass: "car-img-container",
	    style: ({
	      height: _vm.width / 3 * 2 + 'px'
	    })
	  }, [_c('div', {
	    staticClass: "car-img-parent"
	  }, [(_vm.vLazy) ? _c('img', {
	    directives: [{
	      name: "lazy",
	      rawName: "v-lazy",
	      value: (_vm.computedImg),
	      expression: "computedImg"
	    }]
	  }) : _c('img', {
	    attrs: {
	      "src": _vm.computedImg
	    }
	  })]), _vm._v(" "), (_vm.isNew) ? _c('div', {
	    staticClass: "new-icon-parent"
	  }, [_c('img', {
	    attrs: {
	      "src": "//img.souche.com/20170309/png/33d1e2f9c58a75501f15d3a9c351e618.png"
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.data.carStatus === 2) ? _c('div', {
	    staticClass: "sold-icon-parent"
	  }, [_c('img', {
	    attrs: {
	      "src": "//img.souche.com/20170309/png/ae4abcd0ac417154a4e0befe7fdad7a9.png"
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.data.carStatus === 3) ? _c('div', {
	    staticClass: "reserved-icon-parent"
	  }, [_c('img', {
	    attrs: {
	      "src": "//img.souche.com/20170309/png/e396723127b40cc9bc292ddf63d2e2fa.png"
	    }
	  })]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "car-item-content"
	  }, [_c('div', {
	    staticClass: "car-name"
	  }, [_vm._v(_vm._s(_vm.data.fullName))]), _vm._v(" "), _c('div', {
	    staticClass: "car-main"
	  }, [(_vm.isToolNewTangeche) ? [_c('span', {
	    staticClass: "car-main-item"
	  }, [_vm._v(_vm._s(_vm.data.price || '面议'))]), _vm._v(" "), (_vm.data.prepaidLeaseAmount) ? _c('span', {
	    staticClass: "car-main-item"
	  }, [_vm._v("首付" + _vm._s(_vm.data.prepaidLeaseAmount) + "万")]) : _vm._e()] : (_vm.hasTangeche) ? [_c('span', {
	    staticClass: "car-main-item"
	  }, [_c('span', [_vm._v("首付")]), _vm._v(" "), _c('span', {
	    staticClass: "car-main-important"
	  }, [_vm._v(_vm._s(_vm.data.prepaidLeaseAmount))]), _vm._v(" "), _c('span', [_vm._v("万")])]), _vm._v(" "), _c('span', {
	    staticClass: "car-main-item"
	  }, [_vm._v("月供" + _vm._s(_vm.data.installmentPayment) + "元")])] : (_vm.data.price) ? _c('span', [_vm._v(_vm._s(_vm.data.price))]) : _c('span', [_vm._v(_vm._s(_vm.data.price))]), _vm._v(" "), (_vm.supportloan) ? [_c('span', {
	    staticClass: "gap"
	  }, [_vm._v("|")]), _vm._v(" "), _c('span', [_vm._v("首付")]), _vm._v(" "), _c('span', {
	    staticClass: "car-main-important-loan"
	  }, [_vm._v(_vm._s(_vm.data.prepaidLeaseAmount))]), _c('span', [_vm._v("万")])] : _vm._e()], 2), _vm._v(" "), (_vm.hasTangeche && !_vm.isNew && _vm.data.price) ? _c('div', {
	    staticClass: "car-ex"
	  }, [_vm._v("\n            售价 " + _vm._s(_vm.data.price) + "元\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "car-secondary"
	  }, [_c('span', {
	    staticClass: "car-secondary-item"
	  }, [_vm._v(_vm._s(_vm.data.cityName))]), _vm._v(" "), (!_vm.isNew) ? [_c('span', {
	    staticClass: "car-secondary-item"
	  }, [_vm._v(_vm._s(_vm.data.year))]), _vm._v(" "), _c('span', {
	    staticClass: "car-secondary-item"
	  }, [_vm._v(_vm._s(_vm.data.mileage) + "万公里")])] : (_vm.data.newPriceWanStr) ? _c('span', {
	    staticClass: "car-secondary-item"
	  }, [_vm._v("指导价 " + _vm._s(_vm.data.newPriceWanStr) + "万")]) : _vm._e()], 2), _vm._v(" "), (_vm.hasTangeche) ? _c('div', {
	    staticClass: "tangeche-icon-parent"
	  }, [_c('img', {
	    attrs: {
	      "src": "//img.souche.com/20170309/png/f0251232e5efd09e575f9bbd9811f6b6.png"
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.supportloan) ? _c('div', {
	    staticClass: "loan-icon-parent"
	  }, [_c('img', {
	    attrs: {
	      "src": "//img.souche.com/f2e/47793ebdf74b352b51e6bc7f6e7d4159.png"
	    }
	  })]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 106 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "announcement"
	  }, [_c('div', {
	    staticClass: "announcement__text"
	  }, [_vm._l((_vm.announcementText), function(item, index) {
	    return [(index != 0) ? _c('span', [_vm._v("|")]) : _vm._e(), _vm._v(" "), _c('a', {
	      attrs: {
	        "href": _vm.formatUrl(item.url)
	      }
	    }, [_vm._v("\n                    " + _vm._s(item.text) + "\n                ")])]
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "announcement__image"
	  }, [_vm._l((_vm.announcementImage), function(item) {
	    return [_c('a', {
	      attrs: {
	        "href": _vm.formatUrl(item.url)
	      }
	    }, [_c('img', {
	      attrs: {
	        "src": '//img.souche.com/' + item.image,
	        "title": item.text,
	        "alt": item.text
	      }
	    })])]
	  })], 2), _vm._v(" "), _vm._m(0)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "other"
	  }, [_c('a', {
	    attrs: {
	      "href": "/?__mobile=true"
	    }
	  }, [_vm._v("进入手机版")])])
	}]}

/***/ }),
/* 107 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "tangeche tangehce-template-amy-or-souche"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "carsContent"
	  }, [_c('div', {
	    staticClass: "hotNewCars"
	  }, _vm._l((_vm.carListComputed), function(item) {
	    return _c('div', {
	      staticClass: "car-item-container"
	    }, [_c('a', {
	      attrs: {
	        "href": '/car/' + item.id
	      }
	    }, [_c("CarItem", {
	      tag: "div",
	      staticClass: "car-item",
	      class: ['line-height-level-' + _vm.lineHeightLevel],
	      attrs: {
	        "data": item
	      }
	    })])])
	  }))])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "moduleTitle"
	  }, [_vm._v("最新车辆"), _c('a', {
	    staticClass: "more",
	    attrs: {
	      "href": "/buy.htm",
	      "target": "_blank"
	    }
	  }, [_vm._v("更多>>")])])
	}]}

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c("Default", {
	    tag: "div",
	    staticClass: "car-item-large",
	    attrs: {
	      "data": _vm.data,
	      "v-lazy": _vm.vLazy,
	      "width": 280
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "module_newcar",
	    attrs: {
	      "id": 'module_' + _vm.dataId,
	      "data-positionindex": _vm.dataPositionindex,
	      "data-id": _vm.dataId
	    }
	  }, [(_vm.isShow) ? _c(_vm.template, {
	    tag: "div",
	    attrs: {
	      "carList": _vm.carList
	    }
	  }) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "tangeche tangeche-template-amy-or-betty"
	  }, [_c('div', {
	    staticClass: "wrapper"
	  }, [_c('div', {
	    staticClass: "module-title"
	  }, [_vm._v("最新车辆")]), _vm._v(" "), _c('div', {
	    staticClass: "module-desc"
	  }, [_vm._v("新车上架，每天都有新选择")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "module-body"
	  }, [_c('div', {
	    staticClass: "show-card-wrapper"
	  }, _vm._l((_vm.carListComputed), function(item) {
	    return _c('div', {
	      staticClass: "car-item-container"
	    }, [_c('a', {
	      attrs: {
	        "href": '/car/' + item.id
	      }
	    }, [_c("CarItem", {
	      tag: "div",
	      staticClass: "car-item",
	      class: ['line-height-level-' + _vm.lineHeightLevel],
	      attrs: {
	        "data": item
	      }
	    })])])
	  }))])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "module-more"
	  }, [_c('a', {
	    attrs: {
	      "href": "/buy.htm",
	      "target": "_blank"
	    }
	  }, [_vm._v("查看更多")])])
	}]}

/***/ }),
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	
	
	'use strict';
	
	__webpack_require__(191);

/***/ }),
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	
	
	'use strict';
	
	__webpack_require__(59);
	
	__webpack_require__(154);
	
	__webpack_require__(45);
	
	__webpack_require__(46);
	
	__webpack_require__(47);
	
	__webpack_require__(48);
	
	__webpack_require__(49);
	
	__webpack_require__(51);
	
	__webpack_require__(52);
	
	__webpack_require__(53);
	
	__webpack_require__(54);
	
	__webpack_require__(57);
	
	__webpack_require__(58);

/***/ })
]);


// WEBPACK FOOTER //
// static/js/template_betty.js?ts=cf731e30ee39ecf591fa